require('../../../modules/es.function.bind');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Function').bind;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/function/virtual/bind.js
// module id = 983
// module chunks = 0